import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import LabelCDS from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS';
import {
  LabelSize,
  LabelVariant,
} from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import BorrowerCrmAvatar from '../BorrowerCrmAvatar';

import { SEPARATE_APPLICATION_BADGE_LABEL } from './BorrowerNameCell.constants';
import { nameCellStyles, nameTextStyles } from './BorrowerNameCell.styles';

// Borrower Name grid cell: the borrower's name, an optional "Separate application"
// badge, and a read-only CRM contact indicator. The CRM avatar is shown only when
// the EnableCrm feature flag is on, replacing the standalone CRM Contact column.
const BorrowerNameCell = ({ borrower, withCrmAvatar = false }) => (
  <Box sx={nameCellStyles}>
    <Typography
      data-truncated
      className="table-cell__content_text"
      sx={nameTextStyles}
      variant="regular14"
    >
      {borrower.fullName}
    </Typography>
    {borrower.isSeparateApplication && (
      <LabelCDS
        size={LabelSize.S}
        title={SEPARATE_APPLICATION_BADGE_LABEL}
        variant={LabelVariant.BLUE}
      />
    )}
    {withCrmAvatar && <BorrowerCrmAvatar borrowerId={borrower.id} />}
  </Box>
);

BorrowerNameCell.propTypes = {
  borrower: PropTypes.shape({
    id: PropTypes.string,
    fullName: PropTypes.string,
    isSeparateApplication: PropTypes.bool,
  }).isRequired,
  withCrmAvatar: PropTypes.bool,
};

export default memo(BorrowerNameCell);
